export default __webpack_public_path__ + "static/icon-7-5-9f6b6eb63a1a544ad2e9f0c257cfb449.png";